const initDesignGallery = () => {
    if (!window.Swiper) return;

    const main = document.querySelector(".detail-slider");
    const thumbs = document.querySelector(".detail-slider-thumbs");
    if (!main) return;

    let thumbsSwiper = null;
    if (thumbs && thumbs.querySelectorAll(".swiper-slide").length > 1) {
        thumbsSwiper = new window.Swiper(thumbs, {
            slidesPerView: 3.2,
            spaceBetween: 12,
            watchSlidesProgress: true,
            watchOverflow: true,
            breakpoints: {
                576: { slidesPerView: 4.2 },
                992: { slidesPerView: 6.2, spaceBetween: 16 },
            },
        });
    }

    new window.Swiper(main, {
        slidesPerView: 1,
        watchOverflow: true,
        navigation: {
            prevEl: ".detail-slider-prev",
            nextEl: ".detail-slider-next",
        },
        thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
    });
};

initDesignGallery();
